// extracted by mini-css-extract-plugin
module.exports = {"container":"TextBannerCarousel_container__gSqJD","swiper":"TextBannerCarousel_swiper__7FkPh","slide":"TextBannerCarousel_slide__fUiVl","msg":"TextBannerCarousel_msg__QAFZd"};